import RedesignPageLayout from '../components/common/RedesignPageLayout';
import BlogDetail from '../components/blog/BlogDetail';
import { redirectTo } from '../utils/CommonUtil';
import RequestUtil from '../utils/APIRequestUtil';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const getDomain = () => {
    let { domain, sub, subsub } = useParams();
    if (undefined !== sub) {
        domain += '/' + sub;
    }
    if (undefined !== subsub) {
        domain += '/' + subsub;
    }
    return domain;
};

export default function BlogPage() {
    const [loaded, setLoaded] = useState(false);
    const domain = getDomain();

    useEffect(() => {
        RequestUtil.get(`/api/new-domain-names?domainName=${domain}`)
            .then(async (resp) => {
                if (resp.status === 200) {
                    const respBody = await resp.json();
                    redirectTo(`/blogs/${respBody.newDomainName}`);
                    return;
                }
                setLoaded(true);
            })
            .catch(() => setLoaded(true));
    }, [domain]);

    if (!loaded) {
        return null;
    }

    return (
        <RedesignPageLayout>
            <BlogDetail domain={domain} />
        </RedesignPageLayout>
    );
}
